export enum ACTION {
    ADD_TO_WISH_LIST = 'add.wishlist',
    REMOVE_FROM_WISH_LIST = 'pdp.wishlistRemove',
    REMOVE_FROM_WISH_LIST_PLP = 'plp.wishlistRemove',
    EMWBIS_MODAL_OPEN = 'global.modalOpened',
    EMWBIS_SUBMITTED = 'global.emwbisSubmitted',
}

export enum LOCATION {
    PDP_WISH_LIST_WIDGET = 'pdp wishlist widget',
}

export enum DESCRIPTION {
    EMWBIS = 'email me when back in stock (emwbis)',
}
